// requiredPracticals.js — Aggregates all AQA Required Practicals across Bio/Chem/Phys GCSE.
// Surfaces them as a single browsable hub for revision.
import { biologySections, chemistrySections, physicsSections } from './scienceContent';

/**
 * Walks every GCSE section across all three disciplines and pulls topics that
 * have a `requiredPractical` block defined. Adds discipline + section context
 * so we can deep-link from the hub.
 */
export function getAllRequiredPracticals() {
  const out = [];

  const collect = (disciplineSlug, disciplineLabel, sections) => {
    sections
      .filter((s) => s.keyStage === 'ks4')
      .forEach((section) => {
        (section.topics || []).forEach((topic) => {
          if (topic.requiredPractical) {
            out.push({
              disciplineSlug,
              disciplineLabel,
              sectionSlug: section.slug,
              sectionTitle: section.title,
              sectionColor: section.color,
              topicSlug: topic.slug,
              topicTitle: topic.title,
              rp: topic.requiredPractical,
            });
          }
        });
      });
  };

  collect('biology', 'Biology', biologySections);
  collect('chemistry', 'Chemistry', chemistrySections);
  collect('physics', 'Physics', physicsSections);

  return out;
}

export const REQUIRED_PRACTICAL_DISCIPLINE_TOTALS = {
  biology: 6,
  chemistry: 5,
  physics: 5,
};
